import { render, staticRenderFns } from "./ButtonShare.vue?vue&type=template&id=15a5a2a0"
import script from "./ButtonShare.vue?vue&type=script&lang=js"
export * from "./ButtonShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports